import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import FastClick from 'fastclick';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import App from './components/App';
import { authLoginUserSuccess } from './actions/auth';
import configureStore from './store/configureStore';
import './styles/main.scss';

Raven.config('https://ff50ca238f8047a681fcca5d61818291@sentry.io/1248362').install();

const initialState = {};
const store = configureStore(initialState, browserHistory);
const history = syncHistoryWithStore(browserHistory, store);
// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
const context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: (...styles) => {
    // eslint-disable-next-line no-underscore-dangle
    const removeCss = styles.map(x => x._insertCss());
    return () => {
      removeCss.forEach(f => f());
    };
  },
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store,
};

let onRenderComplete = function initialRenderComplete() {
  const elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete() {
    console.log('onRenderComplete');

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    // if (window.ga) {
    //   window.ga('send', 'pageview', createPath(location));
    // }
  };
};

// Make taps on links and buttons work fast on mobiles
FastClick.attach(document.body);

const container = document.getElementById('app');
const routes = require('./routes/index').default(store);

const auth = JSON.parse(sessionStorage.getItem('auth'));
if (auth !== null) {
  store.dispatch(authLoginUserSuccess(auth));
}

// Render the app
let render = () => {
  ReactDOM.render(
    <App context={context}>
      <Router history={history} routes={routes} />
    </App>,
    container,
    () => onRenderComplete(),
  );
};

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render;
    const renderError = (error) => {
      const RedBox = require('redbox-react').default;

      ReactDOM.render(<RedBox error={error} />, container);
    };

    // Wrap render in try/catch
    render = () => {
      try {
        renderApp();
      } catch (error) {
        console.error(error);
        Raven.captureException(error);
        renderError(error);
      }
    };

    // Setup hot module replacement
    module.hot.accept('./routes/index', () =>
      setImmediate(() => {
        render();
      }),
    );
  }
}

render();



// WEBPACK FOOTER //
// src/client.js